import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';

import 'normalize.css/normalize.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';

import { FocusStyleManager } from "@blueprintjs/core";

import Cookies from 'js-cookie';

import { Provider } from 'react-redux';

import './index.css';
import App from './pages/app/App';
import { authentication } from './components/user-access';
import { store, persistor } from './state';
import { PersistGate } from 'redux-persist/integration/react';

fetch('/env.json', {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
}).then(response => {
    if (!response.ok) {
        throw new Error("Could not load settings, please reload");
    }
    return response.json();
}).then(async json => {

    window.env = json;

    var policy = "B2C_1A_StandardLogin";
    var ssoPolicy = Cookies.get('sso');

    if (ssoPolicy != null) {
        policy = `B2C_1A_SSO_${ssoPolicy}`;
    }

    await authentication.initialize({
        auth: {
            clientId: window.env.SSOCLIENTIDSELFADMIN,
            authority: `${window.env.SSOINSTANCEDOMAIN}/tfp/${window.env.SSOTENANT}/${policy}`,
            redirectUri: window.env.SSO_REDIRECT_URL,
            knownAuthorities: [window.env.SSODOMAIN],
            validateAuthority: false
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false
        }
    }, {
        scopes: ["openid", window.env.SSOUSERSCOPE]
    }, {
        scopes: [window.env.SSOUSERSCOPE],
        forceRefresh: false
    });

    FocusStyleManager.onlyShowFocusOnTabs();


    createRoot(document.getElementById('root')).render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    );
    FocusStyleManager.onlyShowFocusOnTabs();

});
